import { TeacherOnboardingModel } from '../../../interfaces/teacher.interface';
import { TeacherOnboardingStatusEnum, UserModel } from '../../../interfaces/user.interface';
import { TeacherOnboardingPagesEnum } from '../TeacherOnboarding';
import { callAPI } from '../../../services/api.service';

export const getOnboardingResumeRoute = (data: TeacherOnboardingModel | null | undefined): string => {
  if (!data) return TeacherOnboardingPagesEnum.OnboardingSchoolInfo;
  if (!data.schoolName) return TeacherOnboardingPagesEnum.OnboardingSchoolInfo;
  if (!data.jobRole || !data.grades?.length) return TeacherOnboardingPagesEnum.OnboardingClassInfo;
  return TeacherOnboardingPagesEnum.OnboardingHowDidYouFindUs;
};

/**
 * Returns the redirect URL for a teacher based on their onboarding status.
 * Returns null for non-teachers or teachers with no status (old teachers).
 */
export const getTeacherRedirectURL = (user: UserModel | null | undefined): string | null => {
  if (!user?.isTeacherMode) return null;
  const status = user.teacherOnboardingStatus;
  if (!status) return null; // Old teacher — no redirect
  switch (status) {
    case TeacherOnboardingStatusEnum.BookOnboarding:
      return '/';
    case TeacherOnboardingStatusEnum.TeacherInfo:
      return TeacherOnboardingPagesEnum.OnboardingSchoolInfo;
    case TeacherOnboardingStatusEnum.Complete:
      return '/classroom/dashboard';
    default:
      return null;
  }
};

/**
 * Calls the API to advance the teacher's onboarding status.
 */
export const updateTeacherOnboardingStatus = async (
  status: TeacherOnboardingStatusEnum,
): Promise<boolean> => {
  try {
    const response = await callAPI('api/surveys/onboarding-status', { status }, 'PUT');
    return response?.status === 200;
  } catch (error) {
    console.error('Failed to update onboarding status:', error);
    return false;
  }
};
